import request from './index'

// 获取分析统计数据（支持 时间范围/批次/分组 筛选，与导出共用同一口径）
export function getStats(params) {
  return request({
    url: '/analytics',
    method: 'get',
    params
  })
}

// 获取用户详情分析
export function getUserDetail(userId) {
  return request({
    url: '/analytics/detail/' + userId,
    method: 'get'
  })
}

// 导出 Excel 报表（生产环境数据量大，放宽超时时间）
export function exportExcel(params) {
  return request({
    url: '/analytics/export',
    method: 'get',
    params,
    responseType: 'blob',
    timeout: 120000
  })
}

// 导出课程明细数据 Excel（2026-10-03 由「推文数据」改名，接口路径不变）
export function exportTweetExcel(params) {
  return request({
    url: '/analytics/export-tweet',
    method: 'get',
    params,
    responseType: 'blob',
    timeout: 120000
  })
}

// 导出阅读明细数据 Excel
export function exportReadDetailExcel(params) {
  return request({
    url: '/analytics/export-read-detail',
    method: 'get',
    params,
    responseType: 'blob',
    timeout: 120000
  })
}
